import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const SuccessLoadable = Loadable({
    loader: () => import('desktop/containers/Success/Success.js' /* webpackChunkName: 'success' */).then(module => module.default),
    loading: () => <Loader />
});

export default SuccessLoadable;
